module.exports = __webpack_public_path__ + "img/hr-V-L-2-unload-connect.3891ddb7.png";